import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Select from "react-select";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { FormControl } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
import "react-datepicker/dist/react-datepicker.css";
import loaderIcon from "assets/img/loader.gif";
import user from "../../../redux/reducers/user";

toastr.options = {
  closeButton: true,
  preventDuplicates: false,
  preventOpenDuplicates: false,
};

const validationStyle = {
  color: "red",
};

class RegisterVipToWebinar extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      full_name: "",
      designation: "",
      // country_code: '65',
      country_code: [],
      country_code_selected: "",
      mobile: "",
      department: "",
      emailId: "",
      loading: false,
      topicList: [],
      options: [
        { value: "chocolate", label: "Chocolate", title: "g" },
        { value: "strawberry", label: "Strawberry", title: "h" },
        { value: "vanilla", label: "Vanilla", title: "h" },
      ],
      salutationList: [
        {
          label: "Prof",
          value: "Prof",
        },
        {
          label: "Mr",
          value: "Mr",
        },
        {
          label: "Mrs",
          value: "Mrs",
        },
        {
          label: "Ms",
          value: "Ms",
        },
        {
          label: "Dr",
          value: "Dr",
        },
      ],
      salutation: null,
      webinar_image: null,
      id: null,
      evt_id: null,
      topic_name: null,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    console.log(id, "idd");
    this.setState({
      loading: true,
      id,
    });
    axios
      .get(`zoom/findAllUpcomingWebinarTopics`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          let topics = [];
          if (res.data.data.length > 0) {
            res.data.data.forEach(function(value) {
              topics.push({
                label: value.topic,
                value: value.id,
              });
            });
          }

          this.setState({
            loading: false,
            topicList: topics,
            evt_id: topics[0].value,
          });
        }
      })
      .catch((error) => {
        toastr.error(error.response.data.message);
      });
    // to get the data of countries
    // axios
    // .get(`users/countrycodeextensions`)
    // .then(res => {
    //   if (res.status === 200 || res.status === 201) {

    //     let country_data_modified;
    //     if (res.data.data.length > 0) {

    //       country_data_modified = res.data.data.map((item,key) => {
    //         return {
    //           ...item,
    //           "value" : item.country_code,
    //           "label" : item.country_extension
    //         }
    //       })

    //     }

    //     this.setState({
    //       loading: false,
    //       country_code: country_data_modified,
    //       // evt_id :  topics[0].value
    //     })
    //   }
    // })
    // .catch(error => {
    //   toastr.error(error.response.data.message);
    // });
    console.log(id);
    if (id !== "addvip") {
      this.fetchVipDetails(id);
    }
  }

  fetchVipDetails = (id) => {
    this.setState({
      loading: true,
    });
    axios
      .get(`users/user-type/8`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          let vipDetails;
          if (res.data.data.length > 0) {
            vipDetails = res.data.data.find((obj) => obj.id === id);
          }
          const {
            department,
            designation,
            email,
            mobile,
            name,
            organisation,
            salutation,
            user_country,
          } = vipDetails;
          this.setState({
            loading: false,
            salutation: { value: salutation, label: salutation },
            full_name: name,
            designation,
            country_code_selected: {
              ...user_country,
              value: user_country.country_code,
              label: user_country.country_extension,
            },
            mobile,
            department,
            organization: organisation,
            emailId: email,
          });
        }
      })
      .catch((error) => {
        toastr.error(error.response.data.message);
      });
  };

  inputHandler = (event) => {
    const { name, value } = event.target;
    if (name === "mobile" && value.length > 12) {
      return toastr.error("Only 12 Digits Mobile No. is allowed!");
    }
    this.setState({ [name]: value });
  };

  inputHandlerName = (event) => {
    const { name, value } = event.target;
    let letters = /^[A-Za-z ]+$/;
    if (name === "full_name" && value.length > 0 && value.match(letters)) {
    } else if (value === "") {
    } else {
      return toastr.error("Digits are not allowed!");
    }
    this.setState({ [name]: value });
  };
  submitForm = () => {
    let {
      action,
      emailId,
      full_name,
      topic_name,
      department,
      topic,
      country_code_selected,
      designation,
      salutation,
      country_code,
      mobile,
      organization,
      evt_id,
      id,
      userCountry,
    } = this.state;
    var mailformat = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    debugger;
    // if (mobile && mobile.length < 8) {
    //   return toastr.error("8 Digits Mobile No. is allowed!");
    // }
    // if (emailId && emailId.match(mailformat)) {
    // } else {
    //   return toastr.error("Please enter valid email!");
    // }
    this.setState({ loading: true });
    if (this.validator.allValid()) {
      const userCountry = {
        id: country_code_selected.id,
        country_name: country_code_selected.country_name,
        country_code: country_code_selected.country_code,
        country_extension: country_code_selected.country_extension,
        country_number_length: country_code_selected.country_number_length,
      };
      console.log(userCountry, country_code_selected, "country_code_selected");

      let requestBody;
      let addPayload = {
        name: full_name,
        email: emailId,
        mobile,
        organisation: organization,
        user_country: userCountry,
        designation,
        department,
        salutation: salutation.value,
        user_type: 8,
      };

      let userRegisterData = {
        email: emailId,
        first_name: full_name,
        last_name: full_name,
        // country: country_code_selected.country_extension,
        country: country_code_selected,
        mobile: mobile,
        org: organization,
        designation: designation,
        salutation: salutation.value,
        department: department,
        topic: topic_name && topic_name.label,
        event_id: topic_name && topic_name.value,
        // country_code: country_code_selected.country_code
      };

      let registerPayload = {
        user_registration_details: [userRegisterData],
        ticket_type: "VIP",
        topic: topic_name && topic_name.label,
        total_booked_tickets: 1,
        transaction_type: "Event_Biooking",
        registered_by: id,
      };

      if (id === "addvip") {
        axios
          .put(`users/addnewuser`, addPayload)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("VIP Booking Created Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
            // toastr.error("Meeting is not found OR already completed")
            toastr.error(error.response.data.message);
          });
      } else {
        console.log(topic_name, "topic_name.value");
        axios
          .post(
            `zoom/registerVIPWebinar?webinar_id=${topic_name.value}`,
            registerPayload
          )
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("VIP Booking Updated Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
            console.log(error.response, "errorrr");
            toastr.error(error.response.data.message);
          });
      }
    } else {
      this.setState({ loading: false });
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    // console.log(this.state.country_code_selected);
    const {
      salutation,
      salutationList,
      full_name,
      designation,
      // country_code,
      country_code,
      mobile,
      department,
      organization,
      loading,
      emailId,
      topicList,
      topic_name,
      id,
      options,
      country_code_selected,
    } = this.state;

    return (
      <div className="add-category-form webinar">
        <Card
          className="vip_main"
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} />
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer>
                    {/* <GridItem md={12}>
                        <FormControl
                          // className={classes.formControl}
                          fullWidth
                          style={{ margin: "0.7rem 0" }}
                        >
                          <legend style={{ fontSize: "1rem" }}>Salutation</legend>
                          <Select

                            name="category"
                            options={salutationList}
                            value={salutation}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(inputValue, actionMeta) => {
                              if (inputValue) {
                                this.setState({
                                  salutation: inputValue
                                });
                              }
                            }}

                          />
                        </FormControl>
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Salutation",
                              salutation,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: full_name ? true : false
                          }}
                          autoFocus
                          margin="dense"
                          id="full_name"
                          name="full_name"
                          label="Full Name*"
                          type="text"
                          fullWidth
                          value={full_name}
                          autocomplete="off"
                          onChange={event => {
                            this.inputHandlerName(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Full Name",
                              full_name,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: designation ? true : false
                          }}
                          margin="dense"
                          id="designation"
                          name="designation"
                          label="Designation*"
                          type="text"
                          fullWidth
                          value={designation}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Designation",
                              designation,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={3}>
                        <TextField
                          InputLabelProps={{
                            shrink: country_code ? true : false
                          }}
                          margin="dense"
                          id="country_code"
                          name="country_code"
                          label="Country Code*"
                          type="number"
                          fullWidth
                          value={country_code}
                          disabled={true}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Country Code",
                              country_code,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={12}>

                        <FormControl
                          // className={classes.formControl}
                          fullWidth
                          style={{ margin: "1.0rem 0" }}
                        >
                          <legend style={{ fontSize: "1rem" }}>Country Code*</legend>
                          <Select

                            name="country_code"
                            // options={options}
                            options={country_code}
                            value={country_code_selected}
                            className="basic-multi-select1"
                            classNamePrefix="select"
                            onChange={(inputValue, actionMeta) => {
                            
                              if (inputValue) {
                                this.setState({
                                  country_code_selected: inputValue
                                });
                              }
                            }}

                          />
                        </FormControl>
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Country Code",
                              country_code_selected,
                              "required"
                            )}
                          </span>
                        }
                        
                        </GridItem> */}

                    {/* <GridItem md={12}>
                        
                        <TextField
                        
                          InputLabelProps={{
                            shrink: mobile ? true : false
                          }}
                          margin="dense"
                          id="mobile"
                          name="mobile"
                          label="Mobile Number*"
                          type="number"
                          fullWidth
                          value={mobile}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Mobile",
                              mobile,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {!(id === "addvip") && (
                      <GridItem md={12}>
                        <FormControl fullWidth style={{ margin: "0.7rem 0" }}>
                          <legend style={{ fontSize: "1rem" }}>
                            Add Webinar
                          </legend>
                          <Select
                            name="category"
                            className="basic-multi-select2"
                            classNamePrefix="select"
                            options={topicList}
                            value={topic_name}
                            onChange={(inputValue, actionMeta) => {
                              if (inputValue) {
                                this.setState({
                                  topic_name: inputValue,
                                });
                              }
                            }}
                          />
                        </FormControl>
                        {/* {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Topic",
                              topic_name,
                              "required"
                            )}
                          </span>
                        } */}
                      </GridItem>
                    )}

                    {/* <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: organization ? true : false
                          }}
                          margin="dense"
                          className="basic-multi-select3"
                          id="organization"
                          name="organization"
                          label="Organization*"
                          type="text"
                          multiline={true}
                          fullWidth
                          value={organization}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Organization",
                              organization,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: department ? true : false
                          }}
                          margin="dense"
                          className="basic-multi-select3"                          
                          id="department"
                          name="department"
                          label="Department*"
                          type="text"
                          multiline={true}
                          fullWidth
                          value={department}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Department",
                              department,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: emailId ? true : false
                          }}
                          disabled={id !== "addvip"}
                          margin="dense"
                          className="basic-multi-select3"
                          id="emailId"
                          name="emailId"
                          label="Enter email ID*"
                          type="email"
                          multiline={true}
                          fullWidth
                          value={emailId}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Email id",
                              emailId,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem> */}

                    {/* <GridItem>
                      <span>Can be Cancelled</span>
                      <Tooltip title="Toggle Status">
                        <Switch
                          checked={
                            cancelled
                            // this.state.ProductList[serial_number.index].is_active
                          }
                          onClick={e => {
                            e.stopPropagation();
                            this.setState({
                              cancelled: !cancelled
                            });
                          }}
                        />
                      </Tooltip>
                    </GridItem> */}
                  </GridContainer>
                </form>
              </CardContent>
              <CardActions style={{ float: "right" }}>
                <Button
                  variant="contained"
                  color="iseas"
                  onClick={this.submitForm}
                >
                  Submit
                </Button>
              </CardActions>
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     categoryListData: state.category,
//     speakerListData: state.speaker
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     handleGetCategoryList: () => dispatch(getAllCategories$.trigger()),
//     handleGetSpeakerList: () => dispatch(getAllSpeakers$.trigger())
//   };
// };

export default connect()(withStyles(extendedFormsStyle)(RegisterVipToWebinar));



// WEBPACK FOOTER //
// ./src/views/ISEAS/vipbooking/RegisterVipToWebinar.js